<template>
  <div v-if="isDecktop" class="tm-order">
    <preloader :is-visible="visiblePreloader"></preloader>
    <RetouchersInactivityTimer
        v-if="isDowntime"
        :downtime="recievedDowntime"
        @is-loading="isLoading = $event"
        @retry="fetchDowntime"/>
    <md-card v-else-if="empty_order === ''">

     <div style="min-height: 100vh;" class="tm-background-dark-white tm-text-small uk-box-shadow-medium tm-senior-retoucher">
        <div class="uk-padding-xsmall">
          <div class="uk-grid uk-grid-small retoucher" data-uk-grid>
            <!--левая часть-->
            <div class="uk-width-expand">
              <div class="uk-panel-scrollable" style="height: calc(100vh - 20px);resize: none;padding: 0;border: none;">
                <RetouchersMainPhotoBlock
                    v-if="creteMainPhotoBlock"
                    :main_photo_block="main_photo_block"
                    :resolution="resolution"
                    :education="education"
                    :with-faces-visible="withFacesVisible"
                    :zone-visible="zoneVisible"
                    :order_number="order_number"
                    :zone_photo="zone_photo"
                    :cost="cost"
                    :afterVisible="afterVisible"
                    :auto_order_check="auto_order_check"
                    :order_photo_after_last_not_education="Number(order_photo_after_last_not_education)"
                    :fullImageList="fullImageList"
                    ref="retouchersMainPhotoBlockRef"
                    @is-loading="isLoading = $event"
                    @retry="reLoadPage"/>
                <!--ПРЕД/СЛЕД заказы-->
                <div class="uk-background-muted uk-padding-small uk-margin-small-top">
                  <prev-orders-block
                      v-if="createPrevBlock"
                      :dataGridCol="'tm-child-width-1-9'"
                      :currRole="'retoucher'"
                      class="uk-animation-slide-small-medium"/>
                </div>
              </div>
            </div>
            <!--правая часть-->
            <div class="uk-width tm-retoucher-order-check-right-side" style="height: calc(100vh - 20px);" v-if="createInfoBlock">
              <!--шапка-->
              <order-card-head
                  :order_number="order_number"
                  :main_photo_before_with_faces="main_photo_before_with_faces"
                  @visible="withFacesVisible = $event"
                  @visible-after="afterVisible = $event"
                  :role="'retoucher'"
                  :education="education"
                  :downtime="computedDowntime"
                  ref="retoucherCardHeaderRef"
                  @auto_order_check="auto_order_check = $event"/>
              <div class="uk-panel-scrollable" style="height: calc(100vh - 75px);resize: none;padding: 0;border: none;">
                <!--описание заказа-->
                <RetouchersInfoBlock
                    :education="education"
                    :order_id="order_id"
                    :main_photo_before_with_faces="main_photo_before_with_faces"
                    :appVersion="computedAppVersion"
                    :main_photo_before="main_photo_before"
                    :resolution="resolution"
                    @zone-visible="zoneVisible = $event"
                    @after-visible="afterVisible = $event"
                    @zone_photo="zone_photo = $event"
                    @loading="infoloading = $event"
                    @order_cost_credits="cost = $event"
                    @faces="faces = $event"
                    @with-faces-visible="withFacesVisible = $event"/>
                <!--чат-->
                <ChatBlock
                    :infoloading="infoloading"
                    v-if="order_chat !== '' && user"
                    :order_chat="order_chat"
                    :role="user.role"
                    :faces="faces"
                    :order_id="Number (order_id)"
                    :user="user.email"
                    :order_photo_after_last_not_education="Number(order_photo_after_last_not_education)"
                    @zone-visible="zoneVisible = $event"
                    @after-visible="afterVisible = $event"
                    @zone_photo="zone_photo = $event"
                    @loading="infoloading = $event"/>
              </div>
            </div>
          </div>
        </div>
      </div>

<!--      <order-card-head-->
<!--          style="margin-top: -21px;"-->
<!--          :order_number="order_number"-->
<!--          :main_photo_before_with_faces="main_photo_before_with_faces"-->
<!--          @visible="withFacesVisible = $event"-->
<!--          @visible-after="afterVisible = $event"-->
<!--          :role="'retoucher'"-->
<!--          :education="education"-->
<!--          :downtime="computedDowntime"-->
<!--          ref="retoucherCardHeaderRef"-->
<!--          @auto_order_check="auto_order_check = $event"/>-->
<!--      <div class="uk-padding-small">-->
<!--        <div class="uk-grid uk-margin" data-uk-grid>-->
<!--          &lt;!&ndash;левая часть&ndash;&gt;-->
<!--          <div class="uk-width-expand">-->
<!--          <div class="uk-panel-scrollable" style="height: calc(100vh - 20px);resize: none;padding: 0;border: none;">-->
<!--          <RetouchersMainPhotoBlock-->
<!--              v-if="creteMainPhotoBlock"-->
<!--              :main_photo_block="main_photo_block"-->
<!--              :education="education"-->
<!--              :with-faces-visible="withFacesVisible"-->
<!--              :zone-visible="zoneVisible"-->
<!--              :order_number="order_number"-->
<!--              :zone_photo="zone_photo"-->
<!--              :cost="cost"-->
<!--              :afterVisible="afterVisible"-->
<!--              :auto_order_check="auto_order_check"-->
<!--              :order_photo_after_last_not_education="order_photo_after_last_not_education"-->
<!--              ref="retouchersMainPhotoBlockRef"-->
<!--              @is-loading="isLoading = $event"-->
<!--              @retry="reLoadPage"/>-->
<!--          </div>-->
<!--        </div>-->
<!--          <div class="uk-width-expand uk-width tm-retoucher-order-check-right-side" v-if="createInfoBlock">-->
<!--            &lt;!&ndash;правая часть&ndash;&gt;-->
<!--            <RetouchersInfoBlock-->
<!--                :education="education"-->
<!--                :order_id="order_id"-->
<!--                :main_photo_before_with_faces="main_photo_before_with_faces"-->
<!--                @zone-visible="zoneVisible = $event"-->
<!--                @after-visible="afterVisible = $event"-->
<!--                @zone_photo="zone_photo = $event"-->
<!--                @loading="infoloading = $event"-->
<!--                @order_cost_credits="cost = $event"-->
<!--                @faces="faces = $event"-->
<!--                @with-faces-visible="withFacesVisible = $event"/>-->
<!--            <ChatBlock-->
<!--                :infoloading="infoloading"-->
<!--                v-if="order_chat !== '' && user"-->
<!--                :order_chat="order_chat"-->
<!--                :role="user.role"-->
<!--                :faces="faces"-->
<!--                :order_id="Number (order_id)"-->
<!--                :user="user.email"-->
<!--                :order_photo_after_last_not_education="order_photo_after_last_not_education"-->
<!--                @zone-visible="zoneVisible = $event"-->
<!--                @after-visible="afterVisible = $event"-->
<!--                @zone_photo="zone_photo = $event"-->
<!--                @loading="infoloading = $event"-->
<!--            ></ChatBlock>-->
<!--          </div>-->
<!--        </div>-->
<!--        <hr class="uk-margin-medium">-->
<!--        <h4 class="uk-margin">{{ local_page_keys.title_previous_orders }}:</h4>-->
<!--        <prev-orders-block v-if="createPrevBlock" :currRole="'retoucher'"></prev-orders-block>-->
<!--      </div>-->


    </md-card>
  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import PrevOrdersBlock from "@/pages/Dashboard/Components/PrevOrdersBlock";
// import HistoryBlock from "@/pages/Dashboard/Components/HistoryBlock";
import OrderCardHead from "@/pages/Dashboard/Components/OrderCardHead";
import RetouchersMainPhotoBlock from "@/pages/Dashboard/Components/for_retouchers/RetouchersMainPhotoBlock";
import RetouchersInfoBlock from "@/pages/Dashboard/Components/for_retouchers/RetouchersInfoBlock";
import RetouchersInactivityTimer from "@/pages/Dashboard/Components/for_retouchers/RetouchersInactivityTimer";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";

export default {
  name: 'RetouchersOrder',
  data: () => ({
    infoloading: false,
    createdowntime: false,
    createPrevBlock: false,
    createHistoryBlock: false,
    creteMainPhotoBlock: false,
    createInfoBlock: false,
    main_photo_block: null,
    main_photo_before_with_faces: null,
    afterVisible: true,
    downtime: null,
    withFacesVisible: false,
    zoneVisible: false,
    zone_photo: null,
    modal_photo: null,
    orderStatus: '',
    empty_order: '',
    isLoading: true,
    order_number: '',
    order_id: '',
    education: null,
    order_photo_after_last_not_education: null,
    modal_photo_before_with_faces: '',
    faces: [],
    local_page_keys: {},
    order_chat: '',
    my_email: '',
    cost: 0,
    role: '',
    is_orders_to_work: true,
    user: '',
    auto_order_check: null,
    getterKey:0,
    recievedDowntime: {},
    interval: null,
    orderPagePathName:'/new_mvp/order',
    orderPagePathNameToRedirect:'/new_mvp/order-func-based',
    resolution: null,
    fullImageList: {},
    isDowntime: true,
    main_photo_before: null,
  }),
  components: {
    PrevOrdersBlock,
    Preloader,
    ChatBlock,
    OrderCardHead,
    RetouchersMainPhotoBlock,
    RetouchersInfoBlock,
    RetouchersInactivityTimer
  },
  methods: {
    async fetchMainPhotoBlock() {
      this.isLoading = true;
      try {
        let data = null;
        if (this.role === 'test-retoucher') {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher", 'retoucher');
        } else {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher");
        }
        data = await this.$store.getters['order/mainPhotoBlock'];

        if (data) {
          if (typeof (data) !== 'string') {
            // this.main_photo_before_with_faces = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.order_photo_before_url_with_faces;
            // this.order_number = data.order_number;
            // this.order_id = data.order_id;
            // this.education = data.education;
            // this.order_photo_after_last_not_education = Number(data.order_photo_after_last_not_education);
            // await this.fetchChatBlock();
            // // Add destruction for data
            // this.main_photo_block = data;
            // this.creteMainPhotoBlock = true;
            // this.createInfoBlock = true;
            // this.createHistoryBlock = true;
            // this.createPrevBlock = true;

            this.main_photo_before_with_faces = this.isURL(data.order_photo_before_url_with_faces) ? data.order_photo_before_url_with_faces : process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.order_photo_before_url_with_faces;
            this.main_photo_before = this.isURL(data.order_photo_before_url) ? data.order_photo_before_url : process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.order_photo_before_url;
            this.resolution = data.resolution;
            this.appVersion = data.app;
            this.order_number = data.order_number;
            this.order_id = data.order_id;
            this.education = data.education;
            this.order_photo_after_last_not_education = data.order_photo_after_last_not_education;
            this.fullImageList = data.order_photo_file_list;
            await this.fetchChatBlock();
            // Add destruction for data
            this.main_photo_block = data;
            this.creteMainPhotoBlock = true;
            this.createInfoBlock = true;
            this.createHistoryBlock = true;
            this.createPrevBlock = true;
          } else {
            this.empty_order = data;
            this.createdowntime = true;
          }
        } else {

          this.errors = this.local_page_keys.alert_failed_main_photo_block;
        }
      }
      catch (e) {
       // alert(e);
        this.isDowntime = true
        this.empty_order = ''
        //this.downtime = true
        //this.fetchDowntime()


      }
      finally {
        this.isLoading = false;
      }

    },

    /**
     * Method for get data of unclosed downtime and availability of new orders in the queue
     * from DowntimeController (method index)
     * identifiable data: isLoading - define as false
     *                    orderStatus - type: string - if there is unclosed downtime defined as 'done'
     **/
    async fetchDowntime() {
      //this.isLoading = true;
      try {
        let data = null;
        await this.$store.dispatch("order/downtimeRetoucher");
        data = await this.$store.getters['order/downtime'];
        this.recievedDowntime = data;
        if (data) {
          //if data is object define what will be displayed timer and button (if there is unclosed downtime), or order in work, or empty-order page (if there is no unclosed downtime)
          if (data.order_in_work === true) {
            this.downtime = null;
            this.isDowntime = false
            await this.fetchMainPhotoBlock();
          } else {
            this.isDowntime = true
            this.downtime = data;
            this.checkOrderPagePath();
            if (!this.is_orders_to_work && data.user_can_take_order) {
              let audio = new Audio('/audio/juntos-607.mp3');
              audio.play();
              this.is_orders_to_work = data.user_can_take_order;
            } else {
              this.is_orders_to_work = data.user_can_take_order;
            }
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_downtime;
        }

      } catch (e) {
        alert(e);
      }
      this.isLoading = false;
    },
    async fetchChatBlock() {
      try {
        let data;
        await this.$store.dispatch("order/historyBlock", this.order_id);
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          //this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    reLoadPage() {
      this.isLoading = true;
      this.order_chat = '';
      this.creteMainPhotoBlock = false;
      this.createInfoBlock = false;
      this.createPrevBlock = false;
      this.fetchDowntime();
    },
    async getOnlyDownTime() {
      await this.$store.dispatch("order/downtimeRetoucher");
      let data = await this.$store.getters['order/downtime'];
      this.recievedDowntime = data;

      const retouchersMainPhotoBlockRef = this.$refs.retouchersMainPhotoBlockRef;
      if (retouchersMainPhotoBlockRef)
        retouchersMainPhotoBlockRef.checkDownloadFile(data);


      const retoucherCardHeaderRef = this.$refs.retoucherCardHeaderRef;
      if (retoucherCardHeaderRef)
        retoucherCardHeaderRef.enableAutoOrder(data);
    },
    async checkOrderPagePath() {
      // await this.$store.dispatch("profile/me");
      // this.user = await this.$store.getters['profile/me'](this.getterKey);
      // if (window.location.pathname === this.orderPagePathName && 'order_page' in this.user && this.user.order_page === 2) {
      //   await this.$router.push(this.orderPagePathNameToRedirect);
      // }
      if (window.location.pathname === this.orderPagePathName) {
        await this.$router.push(this.orderPagePathNameToRedirect);
      }
    },
    isURL(str) {
      if(!str)
        return false;
      return str.startsWith('http://') || str.startsWith('https://');
    },
  },
  async created() {
    this.role = await this.$store.getters['profile/role'];
    this.local_page_keys = await this.$filtergetLocalisationPage('order');
    await this.$store.dispatch('profile/me');
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);
    //this.checkOrderPagePath();
    await this.fetchDowntime();
    this.interval = setInterval(() => {
      this.getOnlyDownTime();
    }, 10000);
  },
  computed: {
    computedAppVersion(){
      return this.appVersion;
    },
    computedDowntime(){
      return this.recievedDowntime;
    },
    isDecktop(){
      //return !(window.matchMedia("(any-pointer:coarse)").matches &&  window.innerWidth <= 1180);
      const navigatorAgent =
          navigator.userAgent || navigator.vendor || window.opera;
      return !(
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
              navigatorAgent
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ \-/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
              navigatorAgent.substr(0, 4)
          )
      );
    },
    isEducation(){
      return this.education;
    },
    visiblePreloader() {
      return this.infoloading || this.isLoading;
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
}
</script>

<style>
/*Layout*/
@import '../../../assets/css/uikit/grid.css';
/*JavaScript*/
@import '../../../assets/css/uikit/sticky.css';
/*Utilities*/
@import '../../../assets/css/uikit/width.css';
@import '../../../assets/css/uikit/height.css';
@import '../../../assets/css/uikit/flex.css';
@import '../../../assets/css/uikit/margin.css';
@import '../../../assets/css/uikit/padding.css';
@import '../../../assets/css/uikit/position.css';
@import '../../../assets/css/uikit/utility.css';
@import '../../../assets/css/uikit/transition.css';
@import '../../../assets/css/uikit/text.css';
@import '../../../assets/css/uikit/overlay.css';
@import '../../../assets/css/custom.css';
</style>
